import { yupResolver } from "@hookform/resolvers/yup";
import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { baseUrl, Fetch } from "../../../shared/Fetch";
import { Button } from "primereact/button";
import { JVInput } from "../../../shared/JVInput";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { InputTextarea } from "primereact/inputtextarea";
import { IWorkStream } from "./WorkStreamList";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { ILogin } from "../../../models/Login";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { Tooltip } from "primereact/tooltip";
interface IForm {
  document_Name?: string;
  description?: string;
}
export interface IWorkStreamFile {
  id?: number;
  tender_ID?: number;
  tender_Title?: string;
  workstream_Category_ID?: number;
  category_Name?: string;
  title?: string;
  description?: string;
  assigned_To?: string;
  assigned_By?: string;
  assigned_At?: Date | null;
}

interface IProps {
  visible: boolean;
  onHide: () => void;
  workStream: IWorkStream | null;
  toast?: any;
  showForm: boolean;
}
const schema = yup.object({});
const WorkStreamDocument = (props: IProps) => {
  const [documents, setDocuments] = useState<any[]>([]);
  const [file, setFile] = useState<File | null>(null);
  const [description, setDescription] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const fileUploadRef = useRef<FileUpload>(null);
  const [descriptionDialog, setDescriptionDialog] = useState<{ visible: boolean; description: string }>({ visible: false, description: "" });

  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  let _roles: Array<number> = [];
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });
  const DateFormat = loginObj.date_Format;
  const emptyForm: IForm = {
    document_Name: "",
    description: "",
  };
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isDirty },
  } = useForm<IForm>({
    defaultValues: emptyForm,
    resolver: yupResolver(schema),
    shouldFocusError: false,
  });
  const fileUploade = async (event: FileUploadHandlerParam) => {
    if (event.files[0].size > (10 * 1024 * 1024)) {
      props.toast.current.show({ severity: "error", content: "Document can not be more than 10 MB." });
      event.options.clear();
    } else {
      props.toast.current.show({ severity: "success", content: "Document Selected." });
      const file = event.files[0];
      setFile(file);
      event.options.clear();
    }
  };

  const loadDocuments = async (id: number) => {
    const response = await Fetch(`TenderWorkstream/GetWorkStreamDocuments/${id}`, "GET", null, null, props.toast);

    if (response?.ok) {
      const data = await response.json();
      setDocuments(data);
    }
  };
  const onSubmit = async (data: any) => {
    if (!file) {
      props.toast.current.show({ severity: "error", detail: "Please select a document." });
      return;
    }
    setLoading(true);

    const formData = new FormData();
    formData.append("Tender_Workstream_ID", props.workStream!.id.toString());
    formData.append("Document_Name", data.document_Name);
    formData.append("Description", description ?? "");
    formData.append("Document", file);

    try {
      const response = await fetch(`${baseUrl}TenderWorkstream/SaveWorkStreamDocument`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`,
        },
        body: formData,
      });

      if (response.ok) {
        props.toast.current.show({ severity: "success", summary: "Success", detail: "Document Uploaded Successfully", life: 3000 });
        clearForm();
        loadDocuments(props.workStream!.id);
      } else {
        const msg = await response.text();
        props.toast.current.show({ severity: "error", summary: "Error", detail: msg, life: 3000 });
      }
      setLoading(false);
    } catch {
      setLoading(false);
      props.toast?.current?.show({ severity: "error", summary: "Error", detail: "Something went wrong", life: 3000 });
    } finally {
      setLoading(false);
    }
  };
  const downloadDoc = async (documentID: number) => {
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/octet-stream",
        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`,
      },
    };
    try {
      const response = await fetch(`${baseUrl}TenderWorkstream/DownloadWorkStreamDocument?documentID=${documentID}`, params);

      if (response.status === 200) {
        const blob = await response.blob();

        const disposition = response.headers.get("content-disposition");
        let fileName = "WorkStream_Document";

        if (disposition) {
          const match = disposition.match(/filename="?([^"]+)"?/);
          if (match?.[1]) {
            fileName = match[1];
          }
        }

        const href = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = href;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        URL.revokeObjectURL(href);
      }
    } catch {
      props.toast?.current?.show({ severity: "error", summary: "Error", detail: "Something went wrong", life: 3000 });
    }
  };

  const downloadBody = (rowData: any) => {
    return rowData.tender_Doc_Path ? <Button icon="pi pi-download" className="p-button-rounded p-button-success p-button-text" tooltip="Download" onClick={() => downloadDoc(rowData.id)} /> : null;
  };
  const clearForm = () => {
    reset(emptyForm);
    setFile(null);
    setDescription("");
    fileUploadRef.current?.clear();
  };

  useEffect(() => {
    if (props.visible && props.workStream) {
      loadDocuments(props.workStream.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible, props.workStream]);

  const deleteDoc = (documentID: number) => {
    confirmDialog({
      header: "Delete Document",
      message: "Are you sure you want to delete this document?",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      acceptLabel: "Delete",
      rejectLabel: "Cancel",

      accept: async () => {
        const response = await Fetch(`TenderWorkstream/DeleteWorkStreamDocument/${documentID}`, "DELETE", null, null, props.toast);

        if (response?.ok) {
          props.toast.current.show({ severity: "success", summary: "Success", detail: "Document Deleted Successfully", life: 3000 });

          loadDocuments(props.workStream!.id);
        } else {
          const msg = await response?.text();

          props.toast.current.show({ severity: "error", summary: "Error", detail: msg || "Delete failed", life: 3000 });
        }
      },
    });
  };

  const deleteBody = (rowData: any) => {
    return <Button icon="pi pi-trash" className="p-button-rounded p-button-danger p-button-text" tooltip="Delete" onClick={() => deleteDoc(rowData.id)} />;
  };
  const canUploadDocument = _roles.includes(1) || _roles.includes(26) || _roles.includes(56) || (!_roles.includes(53) && !_roles.includes(54) && !_roles.includes(55)) || (_roles.includes(55) && props.workStream?.workstream_Category_ID === 3) || (_roles.includes(54) && props.workStream?.workstream_Category_ID === 6);
  return (
    <>
      <ConfirmDialog />
      <Dialog visible={props.visible} onHide={props.onHide} header="Work Stream Documents" style={{ width: "70vw" }} modal>
        {/* (_roles.includes(1) || _roles.includes(26) || (!_roles.includes(53) && !_roles.includes(54) && !_roles.includes(55))) */}
        {props.showForm === true && canUploadDocument && props.workStream?.status !== "Closed" && (
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVInput required column={6} label="Document Title" control={control} name="document_Name" error={errors.document_Name?.message} />
            <div className="field col-12 md:col-6">
              <label htmlFor="file">
                WorkStream Document <span style={{ color: "red" }}>*</span>
              </label>
              <FileUpload ref={fileUploadRef} chooseLabel="Choose Document" mode="basic" name="file" accept="*" maxFileSize={30 * 1024 * 1024} auto customUpload uploadHandler={fileUploade} />
            </div>
            <div className="field col-12">
              <label>Description</label>
              <InputTextarea value={description} onChange={(e) => setDescription(e.target.value)} rows={4} cols={30} className="w-full" placeholder="Enter  description" />
            </div>

            <div className="col-12 flex justify-content-end gap-2">
              <Button label="Save" icon="pi pi-save" type="submit" loading={loading} disabled={!isDirty} />
              <Button label="Clear" icon="pi pi-times" type="button" className="p-button-secondary" onClick={clearForm} />
            </div>
          </form>
        )}

        <DataTable value={documents} responsiveLayout="scroll" stripedRows showGridlines style={{ marginTop: "2rem" }}>
          <Column header="SN" body={(rowData, object) => object.rowIndex + 1} />
          <Column field="document_Name" header="Document Title" />
          <Column
            header="Description"
            body={(rowData: any) =>
              rowData.description ? (
                <>
                  <Tooltip target=".view-description" />

                  <i
                    className="pi pi-eye view-description cursor-pointer"
                    data-pr-tooltip="View Description"
                    data-pr-position="top"
                    style={{
                      color: "var(--primary-color)",
                      fontSize: "1.2rem",
                    }}
                    onClick={() =>
                      setDescriptionDialog({
                        visible: true,
                        description: rowData.description || "",
                      })
                    }
                  />
                </>
              ) : (
                "-"
              )
            }
          />
          <Column field="added_On" header="Added On" body={(rowData: any) => safeFormatDate(rowData.added_On, "dd/MM/yyyy", DateFormat)} style={{ maxWidth: "120px" }} />
          <Column header="Download" body={downloadBody} />
          {(_roles.includes(1) || _roles.includes(26) || _roles.includes(56)) && <Column header="Delete" body={deleteBody} />}
        </DataTable>
      </Dialog>
      <Dialog header="Description" visible={descriptionDialog.visible} modal style={{ width: "40vw" }} onHide={() => setDescriptionDialog({ visible: false, description: "" })}>
        <p style={{ whiteSpace: "pre-wrap" }}>{descriptionDialog.description}</p>
      </Dialog>
    </>
  );
};
export default WorkStreamDocument;
